import { IDeliveryStatus } from "../models/model-interface";

export const updateDeliveryStatus = (deliveryStatus: IDeliveryStatus[], id: string, payload: any): IDeliveryStatus[] => deliveryStatus.map((st) => ({
    ...st,
    currentDeliveryStatus: st.courierId === id ? payload : st.currentDeliveryStatus
}));

export const updateDeliveryStatusOrder = (deliveryStatus: IDeliveryStatus[], id: string, payload: any, orderId: string): IDeliveryStatus[] => deliveryStatus.map((st) => ({
    ...st,
    currentDeliveryStatus: st.courierId === id ? payload : st.currentDeliveryStatus,
    activeOrders: st.activeOrders?.includes(orderId) ? [...st.activeOrders] : [...st.activeOrders as string[], orderId]
}));


export const addDeliveryStatusHelper = (deliveryStatus: IDeliveryStatus[], id: string, payload: any): IDeliveryStatus[] => [
    ...deliveryStatus,
    {
        courierId: id,
        currentDeliveryStatus: payload
    }
]

export const addDeliveryStatusHelperOrder = (deliveryStatus: IDeliveryStatus[], id: string, payload: any, orderId: string): IDeliveryStatus[] => [
    ...deliveryStatus,
    {
        courierId: id,
        currentDeliveryStatus: payload,
        activeOrders: [orderId]
    }
]


export const removeDeliveryStatus = (deliveryStatus: IDeliveryStatus[], id: string): IDeliveryStatus[] => deliveryStatus.filter((d) => d.courierId !== id);
export const removeActiveOrders = (deliveryStatus: IDeliveryStatus[], courierId: string, orderId: string): IDeliveryStatus[] => { // find the affeected courier, // copyu the current state , update the current state with removed items
    const activeOrders = deliveryStatus.map((s) => s).find((d) => d.courierId === courierId)?.activeOrders?.filter((f) => f !== orderId);
    const asa = deliveryStatus.filter((a) => a.courierId !== courierId).map((st) => ({
        ...st,
        activeOrders: activeOrders
    }))
    return {
        ...deliveryStatus,
        ...asa
    }
};